import React, { useEffect, useState } from 'react'
import { Button, Col, Row, Spin } from 'antd'
import { observer } from 'mobx-react-lite'
import { useNavigate } from 'react-router-dom'
import { useStores } from '../../../cls/stores/MobXProvider'
import SubscriptionOptions from './SubscriptionOptions'
import {
	GeneralContentWrapper,
	GeneralTourTitle
} from '../../../components/Shared/GeneralComponents'
import { getTourArrayByKeys } from '../../../stores/tour/config'
import ActiveSubscriptions from './ActiveSubscriptions'
import { useSmartTranslation } from '../../../cls/TranslationContext'
import ActivePurchases from './ActivePurchases'
import ServiceOverview from './ServiceOverview'

const Subscriptions = () => {
	const navigate = useNavigate()
	const { t } = useSmartTranslation()
	const [loadingItm, setLoadingItm] = useState(true)
	// State to manage the current active tab that contains the Collapse
	const [activeTab, setActiveTab] = useState('options')

	const { tourStore } = useStores()
	const { users } = useStores()
	const { loggedInUserId } = users

	useEffect(() => {
		if (!users.isLoggedIn) {
			navigate('/logout')
			return
		}

		setLoadingItm(false)
	}, [loggedInUserId])

	if (loadingItm) {
		return (
			<div style={{ textAlign: 'center' }}>
				<p>Loading...</p>
				<Spin />
			</div>
		)
	}

	const billingList = getTourArrayByKeys('billingList', ['all'])

	const startTour = () => {
		tourStore.startTour('BillingList-tour', [...billingList])
	}

	return (
		<GeneralContentWrapper>
			{loggedInUserId && (
				<>
					<GeneralTourTitle
						titleProps={{ text: t('_subscription.multiple') }}
						buttonProps={{
							onClick: startTour
						}}
					/>

					<Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
						<Col>
							<Button
								id="target-button-details"
								type={
									activeTab === 'options'
										? 'primary'
										: 'default'
								}
								onClick={() => setActiveTab('options')}
							>
								{t('single.catalog')}
							</Button>
						</Col>
						<Col>
							<Button
								id="target-button-preferences"
								type={
									activeTab === 'subscriptions'
										? 'primary'
										: 'default'
								}
								onClick={() => setActiveTab('subscriptions')}
							>
								{t('single.subscription.my-subscriptions')}
							</Button>
						</Col>
						<Col>
							<Button
								id="target-button-purchases"
								type={
									activeTab === 'purchases'
										? 'primary'
										: 'default'
								}
								onClick={() => setActiveTab('purchases')}
							>
								{t('single.subscription.one-time-purchases')}
							</Button>
						</Col>
					</Row>

					{activeTab === 'options' && <ServiceOverview />}
					{activeTab === 'options' && <SubscriptionOptions />}
					{activeTab === 'subscriptions' && <ActiveSubscriptions />}
					{activeTab === 'purchases' && <ActivePurchases />}
				</>
			)}
		</GeneralContentWrapper>
	)
}

export default observer(Subscriptions)
